import HttpException from 'exceptions/HttpException'

export default class HttpInvalidRequestException extends HttpException {
  constructor(message, ...args) {
    super('Invalid Request', message, ...args)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpInvalidRequestException)
    }

    this.code = 400
  }
}
